import { AxiosInstance } from 'axios';
import auth from '../../../apis/auth';
import { Pagination } from '../../../shared/models/pagination';
import { Coupom } from '../models/coupom';
import { CoupomCustomization } from '../models/customization';
import { VtexCoupom } from '../models/vtex-coupom';

type CreateCouponInput = {
  coupom_source_id: string;
  customization: CoupomCustomization;
  source: 'vtex';
};

export class CoupomAPI {
  private readonly client: AxiosInstance = auth;

  async findAll(data?: {
    limit?: number;
    page?: number;
    search?: string;
  }): Promise<Pagination<Coupom>> {
    const { data: response } = await this.client.get<Pagination<Coupom>>(
      '/coupons',
      {
        params: data,
      },
    );
    response.data = response.data.map(item => new Coupom(item));
    return response;
  }

  async findOne(id: string): Promise<Coupom> {
    const { data } = await this.client.get<Coupom>(`/coupons/${id}`);
    return new Coupom(data);
  }

  async create(data: CreateCouponInput): Promise<Coupom> {
    const { data: response } = await this.client.post<Coupom>('/coupons', data);
    return response;
  }

  async update(
    id: string,
    customization: CoupomCustomization,
  ): Promise<Coupom> {
    const { data } = await this.client.put<Coupom>(`/coupons/${id}`, {
      customization,
    });
    return data;
  }

  async delete(id: string): Promise<void> {
    await this.client.delete(`/coupons/${id}`);
  }

  async findVtexCoupons(): Promise<VtexCoupom[]> {
    const { data: response } = await this.client.get<{ data: VtexCoupom[] }>(
      '/coupons/vtex',
    );
    return response.data.map(item => new VtexCoupom(item));
  }

  async findVtexCouponById(id: string): Promise<VtexCoupom> {
    const { data } = await this.client.get<
      VtexCoupom & { beginDateUtc: string; endDateUtc: string }
    >(`/coupons/vtex/${id}`);
    return new VtexCoupom({
      ...data,
      beginDate: new Date(data.beginDateUtc),
      endDate: new Date(data.endDateUtc),
    });
  }
}
